import React, { Component } from 'react';
import classNames from 'classnames';
import { Tooltip, Popconfirm } from 'antd';
import PropTypes from 'prop-types';


import { IconEdit, IconDelete, } from '../../../../../../../../data/assets/icons';

class WorkflowNode extends Component {
    render() {
        const { model, removeNode, editWorkflowNode } = this.props;

        if (model) {
            return (
                <div className={classNames("ori-animated ori-zoom-in ori-pad-5 ori-bg-white  ori-border-radius-4 ori-box-shadow-warning ori-border-dashed-warning")} style={{ width: "240px", minHeight: "120px" }}>
                    <div className="ori-relative ori-r-pad-30 ori-b-pad-5">
                        <div className="ori-flex" style={{ minHeight: '22px' }}>
                            {
                                model && model.nextWId &&
                                <div className="ori-font-xs ori-lr-pad-10 ori-bg-warning ori-font-white ori-border-radius-10" style={{ height: '20px', lineHeight: '20px' }}>
                                    <span>NWID {model.nextWId}</span>
                                </div>
                            }
                            {
                                model && model.nextNodeId &&
                                <div className="ori-l-mrgn-5 ori-font-xs ori-lr-pad-10 ori-bg-warning ori-font-white ori-border-radius-10" style={{ height: '20px', lineHeight: '20px' }}>
                                    <span>NNID {model.nextNodeId}</span>
                                </div>
                            }
                        </div>
                        <div className="ori-absolute ori-align-top-neg-5 ori-align-right ori-flex-row">
                            <div className="ori-cursor-ptr ori-pad-3" onClick={() => { editWorkflowNode(model) }}>
                                <Tooltip overlayClassName="ori-tooltip-tag" placement="top" title="Edit Workflow">
                                    <IconEdit size={14} className="ori-font-light" />
                                </Tooltip>
                            </div>
                            <Popconfirm placement="top" title="Are you sure delete this Workflow?" okText='Yes' cancelText='No' onConfirm={() => removeNode(model.id)}>
                                <div className="ori-cursor-ptr ori-pad-3">
                                    <Tooltip overlayClassName="ori-tooltip-tag" placement="top" title="Delete Workflow">
                                        <IconDelete size={16} className="ori-font-light" />
                                    </Tooltip>
                                </div>
                            </Popconfirm>
                        </div>
                    </div>
                    {
                        model.workflowName &&
                        <p className="ori-font-xs ori-capitalize-first ori-text-left ori-font-bold">{model.workflowName}</p>
                    }
                    <div className="ori-block-text-overflow-dotted ori-dotted-after-xxs-3 ori-b-pad-5">
                        {
                            model.description &&
                            <p className="ori-font-xxs ori-capitalize-first ori-text-left">{model.description}</p>
                        }
                    </div>
                </div>
            );
        } else {
            return null;
        }

    }
}

WorkflowNode.propTypes = {
    model: PropTypes.object,
    removeNode: PropTypes.func,
    editWorkflowNode: PropTypes.func,
};

export default WorkflowNode;


// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/workflows/workflowdiagram/flowdiagram/workflownode/index.js